import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/dsk-payment-provider/';

interface DTO {
    parkingId: string;
}

export interface DSKPaymentProvider {
    id: string;
    username: string;
    password: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId }: DTO): Promise<ListResponseSmartParkAPI<DSKPaymentProvider>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetDSKPaymentProvider, RESOURCE as DSK_PAYMENT_PROVIDER_RESOURCE };
